import { j as _typeof, _ as _slicedToArray, g as _toConsumableArray, e as _objectSpread2 } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { C as Card } from './Card-683c5834.js';
import Title from './Title.js';
import Radio from './Radio.js';
import PaymentAdviceRow from './PaymentAdviceRow.js';
import PanelTitle from './PanelTitle.js';
import Divider from './Divider.js';
import { a as FormattedNumber } from './index-c101e2b0.js';
import './PropTypes-9aad034b.js';
import 'moment';
import './Slider.js';
import 'rc-slider/lib/Slider';
import './Icon.js';
import './_commonjsHelpers-97e6d7b1.js';
import './Button-9db40655.js';
import './utilsHelpers-21a239d9.js';
import './Modal.js';
import 'react-dom';
import './ModalHeader-daaa2bf6.js';
import './tslib.es6-2748fcb6.js';
import './useIntl-2030d1c8.js';
import './injectIntl-0da7053c.js';
import './hoist-non-react-statics.cjs-596f6afc.js';
import './index-c093c499.js';
import './provider-b3aa55fe.js';

/**
 * Returns a new array containing the elements from the first array that are not present in the second array.
 *
 * @param {Array} array - The array to compare.
 * @param {Array} values - The array of values to exclude.
 * @returns {Array} - A new array containing the difference between the two arrays.
 */
function difference(array, values) {
  if (!Array.isArray(array) || !Array.isArray(values)) {
    throw new TypeError('Both arguments must be arrays.');
  }
  var valuesSet = new Set(values);
  return array.filter(function (element) {
    return !valuesSet.has(element);
  });
}

/**
 * Sorts an array of objects based on the specified keys and orders.
 *
 * @param {Array} array - The array to be sorted.
 * @param {string|string[]} keys - The key(s) to sort the array by.
 * @param {string|string[]} orders - The sort order(s) for each key. Defaults to 'asc'.
 * @returns {Array} - The sorted array.
 * @throws {Error} - If the first parameter is not an array or if array elements are not objects.
 */
function orderBy(array, keys, orders) {
  if (!Array.isArray(array)) {
    throw new Error('The first parameter must be an array.');
  }
  keys = Array.isArray(keys) ? keys : [keys];
  orders = Array.isArray(orders) ? orders : [orders];
  return array.slice().sort(function (a, b) {
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var order = orders[i] || 'asc';
      if (_typeof(a) !== 'object' || _typeof(b) !== 'object') {
        throw new Error('Array elements must be objects.');
      }
      if (a[key] < b[key]) {
        return order === 'asc' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return order === 'asc' ? 1 : -1;
      }
    }
    return 0;
  });
}

var buildDescription = function buildDescription(objDescription, description) {
  return (objDescription === null || objDescription === void 0 ? void 0 : objDescription.length) ? objDescription.map(function (priceItem, index) {
    var itemKey = "price_item_".concat(index);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: itemKey
    }, "".concat(index > 0 ? ' + ' : '', " "), /*#__PURE__*/React__default.createElement("span", {
      className: "price-element-value-".concat(priceItem.amount, "-currency-").concat(priceItem.currency.replace(/\s/g, ''))
    }, "".concat(priceItem.amount)), /*#__PURE__*/React__default.createElement("span", {
      className: "price-element-currency-".concat(priceItem.currency)
    }, " ".concat(priceItem.currency)));
  }) : description;
};
var createPaymentOptionGroups = function createPaymentOptionGroups(paymentOptionGroups, defaultOptions, name, defaultSelectedId, modalInfo) {
  return (paymentOptionGroups === null || paymentOptionGroups === void 0 ? void 0 : paymentOptionGroups.map(function (_ref) {
    var title = _ref.title,
      displayIndividualLabels = _ref.displayIndividualLabels,
      options = _ref.options,
      isSlider = _ref.isSlider;
    return {
      title: title,
      displayIndividualLabels: displayIndividualLabels,
      isSlider: isSlider,
      options: options.map(function (_ref2) {
        var description = _ref2.description,
          id = _ref2.id,
          balanceCategory = _ref2.balanceCategory,
          cashBalance = _ref2.cashBalance,
          disabled = _ref2.disabled,
          extraDetails = _ref2.extraDetails,
          objDescription = _ref2.objDescription,
          label = _ref2.label,
          slider = _ref2.slider,
          pointsBalancesToBeConsumed = _ref2.pointsBalancesToBeConsumed;
        return {
          id: id,
          value: "".concat(id, "_").concat(name),
          content: displayIndividualLabels ? label : buildDescription(objDescription, description),
          description: displayIndividualLabels ? buildDescription(objDescription, description) : null,
          checked: id === defaultSelectedId,
          // Preferred by default
          balanceCategory: balanceCategory,
          cashBalance: cashBalance,
          disabled: disabled,
          extraDetails: extraDetails,
          modalInfo: modalInfo,
          slider: slider,
          pointsBalancesToBeConsumed: pointsBalancesToBeConsumed
        };
      })
    };
  })) || [{
    options: defaultOptions
  }];
};
var PaymentOptionGroups = function PaymentOptionGroups(_ref3) {
  var _balanceOptionTypes$, _balanceOptionTypes$$;
  var paymentOptionGroups = _ref3.paymentOptionGroups,
    onSelectPaymentOptionGroups = _ref3.onSelectPaymentOptionGroups,
    name = _ref3.name,
    totalToPay = _ref3.totalToPay,
    balancesList = _ref3.balancesList,
    currencyDisplay = _ref3.currencyDisplay,
    userCurrency = _ref3.userCurrency,
    upgrades = _ref3.upgrades,
    fractionDigits = _ref3.fractionDigits,
    defaultOptions = _ref3.defaultOptions,
    noPaymentsMessage = _ref3.noPaymentsMessage,
    defaultSelectedId = _ref3.defaultSelectedId,
    modalInfo = _ref3.modalInfo,
    showButtons = _ref3.showButtons;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    balancesDetails = _useState2[0],
    setBalancesDetails = _useState2[1];
  var _useState3 = useState(createPaymentOptionGroups(paymentOptionGroups, defaultOptions, name, defaultSelectedId, modalInfo)),
    _useState4 = _slicedToArray(_useState3, 2),
    balanceOptionTypes = _useState4[0],
    setBalanceOptionTypes = _useState4[1];
  var _useState5 = useState({
      id: defaultSelectedId
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedBalance = _useState6[0],
    setSelectedBalance = _useState6[1]; // Preferred by default

  var handleAvailability = function handleAvailability(totalOptions, availableOptions, key) {
    var checkValueExist = function checkValueExist(valueToSearch) {
      return availableOptions.some(function (o) {
        return o[key] === valueToSearch;
      });
    };
    var checkedOptions = totalOptions.map(function (option) {
      if (checkValueExist(option[key]) || option[key] === 0) {
        // 0 = preferred
        return option;
      }
      return _objectSpread2(_objectSpread2({}, option), {}, {
        // TODO decouple logic, option was disabled based on balances
        disabled: !paymentOptionGroups && true
      });
    });
    return checkedOptions;
  };
  var sortBalances = useCallback(function (selectedOption) {
    var balancesMatched = balancesList === null || balancesList === void 0 ? void 0 : balancesList.filter(function (balance) {
      var selectedClubOrBonus = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.balanceCategory) === (balance === null || balance === void 0 ? void 0 : balance.balanceCategory);
      var selectedPreferred = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.balanceCategory) === 0;
      return selectedClubOrBonus || selectedPreferred;
    });
    var balancesNotMatched = difference(balancesList, balancesMatched);
    var orderByDateMatched = orderBy(balancesMatched, 'expiryDate', 'asc');
    var orderByDateNotMatched = orderBy(balancesNotMatched, 'expiryDate', 'asc');
    return [].concat(_toConsumableArray(orderByDateMatched), _toConsumableArray(orderByDateNotMatched));
  }, [balancesList]);
  var discountPoints = useCallback(function (tmpBalances) {
    var totalToDiscount = totalToPay;
    var newBalances = tmpBalances.map(function (balance) {
      var newAmount = balance.balance - totalToDiscount;
      if (newAmount < 0 && totalToDiscount !== 0) {
        totalToDiscount -= balance.balance;
        return _objectSpread2(_objectSpread2({}, balance), {}, {
          amount: 0,
          discounted: balance.balance
        });
      }
      var discounted = totalToDiscount;
      totalToDiscount = 0;
      return _objectSpread2(_objectSpread2({}, balance), {}, {
        amount: newAmount,
        discounted: discounted
      });
    });
    return newBalances;
  }, [totalToPay]);
  var filterBalances = function filterBalances(sortedBalances, selectedOption) {
    var balancesForSelectedOption = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.pointsBalancesToBeConsumed;
    var filteredBalances = sortedBalances.filter(function (balance) {
      return balancesForSelectedOption && balancesForSelectedOption.includes(balance.id);
    });
    return filteredBalances;
  };
  var handleSelected = useCallback(function (_ref4) {
    var _selected;
    var id = _ref4.id;
    var selected = null;
    balanceOptionTypes.forEach(function (_ref5) {
      var options = _ref5.options;
      if (selected === null) {
        var findOption = options.find(function (type) {
          return type.id === id;
        });
        if ((findOption === null || findOption === void 0 ? void 0 : findOption.id) >= 0) {
          selected = findOption;
        }
      }
    });
    setBalanceOptionTypes(function (prev) {
      return _toConsumableArray(prev.map(function (items) {
        return _objectSpread2(_objectSpread2({}, items), {}, {
          options: _toConsumableArray(items.options.map(function (option) {
            return _objectSpread2(_objectSpread2({}, option), {}, {
              checked: option.id === id
            });
          }))
        });
      }));
    });
    setSelectedBalance(selected);
    var sortedBalances = sortBalances(selected);
    var newBalances = discountPoints(sortedBalances);
    var balancesToBeUsed = filterBalances(sortedBalances, selected);

    // these balances are used to calculate whether the user is in debts or not
    onSelectPaymentOptionGroups(balancesToBeUsed, (_selected = selected) === null || _selected === void 0 ? void 0 : _selected.balanceCategory, !!paymentOptionGroups, selected);

    // TODO review this logic, it is not clear what is the purpose of this function ->setBalancesDetails
    setBalancesDetails(newBalances);
  }, [balanceOptionTypes, sortBalances, discountPoints, onSelectPaymentOptionGroups, paymentOptionGroups]);
  var handleComponentMount = function handleComponentMount() {
    handleSelected({
      id: selectedBalance.id
    });
    var balanceTypeAvailability = handleAvailability(balanceOptionTypes, balancesDetails, 'balanceCategory');
    setBalanceOptionTypes(balanceTypeAvailability);
  };
  useEffect(function () {
    handleComponentMount();
  }, [totalToPay]); //eslint-disable-line

  var renderOptionSelector = totalToPay > 0;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, upgrades.length ? upgrades.map(function (upgrade) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: upgrade.id
    }, /*#__PURE__*/React__default.createElement(PaymentAdviceRow, {
      title: upgrade.title,
      content: /*#__PURE__*/React__default.createElement(PanelTitle, {
        size: "large",
        content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
          className: "price-element-value-".concat(upgrade.price, "-currency-").concat(upgrade === null || upgrade === void 0 ? void 0 : upgrade.currency_code)
        }, upgrade.price), "\xA0", /*#__PURE__*/React__default.createElement("span", {
          className: "price-element-currency-".concat(upgrade.currency_code)
        }, "".concat(upgrade.currency_code))),
        className: "margin-bottom-removed"
      })
    }), /*#__PURE__*/React__default.createElement(Divider, null));
  }) : null, renderOptionSelector && ((_balanceOptionTypes$ = balanceOptionTypes[0]) === null || _balanceOptionTypes$ === void 0 ? void 0 : (_balanceOptionTypes$$ = _balanceOptionTypes$.options) === null || _balanceOptionTypes$$ === void 0 ? void 0 : _balanceOptionTypes$$.length) ? /*#__PURE__*/React__default.createElement("div", {
    className: "multiple-banking-wrapper"
  }, balanceOptionTypes.map(function (group, index) {
    var key = "BANKING_OPTIONS_GROUP_".concat(index);
    return /*#__PURE__*/React__default.createElement(Card, {
      className: "multiple-banking-group",
      key: key
    }, group.title ? /*#__PURE__*/React__default.createElement(Title, {
      content: group.title,
      className: "multiple-banking-group-title"
    }) : null, /*#__PURE__*/React__default.createElement(Radio, {
      options: group.options,
      name: name,
      onChange: handleSelected,
      isSlider: group.isSlider,
      defaultSelectedId: defaultSelectedId,
      showButtons: showButtons
    }));
  })) : null, !paymentOptionGroups && balancesDetails.length && !defaultOptions.length ? balancesDetails.map(function (balance) {
    return balance.discounted && balance.discounted !== 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: balance.id
    }, /*#__PURE__*/React__default.createElement(PaymentAdviceRow, {
      title: balance.name,
      content: /*#__PURE__*/React__default.createElement(PanelTitle, {
        size: "large",
        content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, '-', /*#__PURE__*/React__default.createElement(FormattedNumber, {
          currency: userCurrency,
          currencyDisplay: currencyDisplay,
          value: balance.discounted,
          fractionDigits: fractionDigits
        })),
        className: "margin-bottom-removed"
      })
    }), /*#__PURE__*/React__default.createElement(Divider, null)) : null;
  }) : null, !paymentOptionGroups && !defaultOptions.length ? /*#__PURE__*/React__default.createElement(PaymentAdviceRow, {
    title: noPaymentsMessage ? /*#__PURE__*/React__default.createElement(PanelTitle, {
      content: noPaymentsMessage,
      className: "margin-bottom-removed"
    }) : null,
    content: /*#__PURE__*/React__default.createElement(PanelTitle, {
      size: "large",
      className: "text-accent margin-bottom-removed",
      content: /*#__PURE__*/React__default.createElement(FormattedNumber, {
        currency: userCurrency,
        currencyDisplay: currencyDisplay,
        fractionDigits: fractionDigits,
        value: totalToPay
      })
    })
  }) : null);
};
PaymentOptionGroups.defaultProps = {
  name: 'payment-option-groups',
  upgrades: [],
  defaultOptions: [],
  paymentOptionGroups: null,
  noPaymentsMessage: null,
  defaultSelectedId: 0,
  modalInfo: {
    title: null,
    triggerText: null,
    total: null
  },
  balancesList: [],
  showButtons: false
};
PaymentOptionGroups.propTypes = {
  paymentOptionGroups: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired
  })),
  onSelectPaymentOptionGroups: PropTypes.func.isRequired,
  name: PropTypes.string,
  totalToPay: PropTypes.number.isRequired,
  balancesList: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number
  })),
  currencyDisplay: PropTypes.string.isRequired,
  userCurrency: PropTypes.shape({
    code: PropTypes.string,
    symbol: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  upgrades: PropTypes.arrayOf(PropTypes.shape({})),
  fractionDigits: PropTypes.number.isRequired,
  defaultOptions: PropTypes.arrayOf(PropTypes.shape({})),
  noPaymentsMessage: PropTypes.string,
  defaultSelectedId: PropTypes.number,
  modalInfo: PropTypes.shape({
    title: PropTypes.string,
    triggerText: PropTypes.string,
    total: PropTypes.string
  }),
  showButtons: PropTypes.bool
};

export default PaymentOptionGroups;
